import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Model } from 'vue-property-decorator';
import { FormConstructor } from '@/types/form-constructor';
import FormResStatus from '@/api/form-res-status';
import { required } from 'vuelidate/lib/validators';
import REQ_URL from '@/consts/req-url';
import { ResData } from '@/types/response-data';

@Component({
    validations(this: SimpleFormDialog) {
        let v: any = {
            formData: {

            }
        }
        this.formConstructor.forEach((el) => {
            if (el.required || el.validator)
                v.formData[el.name] = {
                    [el.validator ? el.validator.name : 'required']: el.validator ? el.validator : required
                }
        })
        return v
    }
} as any)
export default class SimpleFormDialog extends Vue {
    @Prop({ default: [], required: true }) formConstructor!: FormConstructor
    @Prop({ default: '500px' }) maxWidth!: string | number
    @Prop({ default: '' }) title!: string
    @Prop({ default: () => undefined }) payloadFunc!: Function
    @Prop({ required: true }) reqUrl!: keyof typeof REQ_URL
    @Model('change', { default: false }) open!: boolean
    formData = {}
    formStatus = new FormResStatus()

    get show() {
        return this.open
    }
    set show(val: boolean) {
        this.$emit('update:open', val)
    }
    async submit() {
        this.$v.$touch();
        if (!this.$v.$error) {
            try {
                let data = await this.$fetch<ResData<any>>(REQ_URL[this.reqUrl], {
                    method: 'POST',
                    body: JSON.stringify({
                        form: this.formData,
                        data: this.payloadFunc()
                    }),
                    credentials: 'same-origin'
                }, this.formStatus)

                if (data.msg) {
                    this.$emit('update:open', false)
                    this.$v.$reset();
                    this.formStatus.reset();
                    this.$store.commit('modal:open', {
                        type: 'success',
                        msg: data.msg
                    })

                }
                else throw new Error(data.error)
            } catch (error) {
                console.error(error.message)
                if (error.code === 901) {
                    this.$emit('update:open', false)
                    this.$v.$reset();
                    this.formStatus.reset();
                    this.$store.commit('modal:open', {
                        type: 'warning',
                        msg: error.message
                    })
                }

            }
            this.formStatus.pending = false;
        }
    }
    mounted() {
        this.formConstructor.forEach((el) => {
            this.$set(this.formData, el.name, el.defaultValue ? el.defaultValue : '')
        })
    }
}